const CHUNK_LOAD_ERROR =
  /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unable to preload CSS for|ChunkLoadError/i;

const CHUNK_RELOAD_SESSION_KEY = 'abrafi:chunk-reload-attempted';

export function isChunkLoadError(error: unknown): boolean {
  if (error instanceof Error) {
    return CHUNK_LOAD_ERROR.test(error.message);
  }
  if (typeof error === 'string') {
    return CHUNK_LOAD_ERROR.test(error);
  }
  return false;
}

/** Cleared after a successful full page load so a later deploy can auto-reload once. */
export function clearChunkReloadAttempt(): void {
  try {
    sessionStorage.removeItem(CHUNK_RELOAD_SESSION_KEY);
  } catch {
    // sessionStorage may be unavailable (private mode, blocked)
  }
}

/**
 * After a deploy, users with an old bundle may request missing JS chunks.
 * One automatic reload usually fixes it; avoid infinite reload loops.
 */
export function tryReloadOnceForChunkLoadError(error: unknown): boolean {
  if (!isChunkLoadError(error)) {
    return false;
  }

  try {
    if (sessionStorage.getItem(CHUNK_RELOAD_SESSION_KEY) === '1') {
      return false;
    }
    sessionStorage.setItem(CHUNK_RELOAD_SESSION_KEY, '1');
  } catch {
    return false;
  }

  window.location.reload();
  return true;
}
